const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "19%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "10%"
  },
  {
    key: "exhaustPressure",
    zh: "排气压力(MPa)",
    en: "Exhaust Pressure(MPa)",
    width: "15%",
    tooltip: true
  },
  {
    key: "exhaustTemperature",
    zh: "排气温度(℃)",
    en: "Exhaust Temperature(℃)",
    width: "15%",
    tooltip: true
  },
  {
    key: "inverterTemperature",
    zh: "变频温度(℃)",
    en: "Inverter Temperature(℃)",
    width: "15%",
    tooltip: true
  },
  {
    key: "runTime",
    zh: "累积运行时间(h)",
    en: "Run Time(h)",
    width: "12%",
    tooltip: true
  }
]

export default columns